import administradorRoutes from './userTypes/administrador.routes';
import ejecutivoRoutes from './userTypes/ejecutivo.routes';
import supervisorRoutes from './userTypes/supervisor.routes';
import especialistaRoutes from './userTypes/especialista.routes';
import liftlogicRoutes from './userTypes/liftlogic.routes';

// Devuelve las rutas registradas en React Router para cada userType, filtrando:
//   - Catchall (path '/*') — no es navegable.
//   - Rutas con params dinámicos (contienen ':') — un menu_item apunta a
//     paths estáticos; rutas con params se construyen al navegar y no tiene
//     sentido ofrecerlas como destino fijo desde el sidebar.
//
// Consumido por `MenuItemForm` para poblar el Select de ruta filtrado por
// userType. Si se agrega una nueva ruta registrada en `userTypes/*.routes.js`,
// aparece aquí automáticamente — fuente única de verdad.

const toPaths = (routes) => {
  if (!Array.isArray(routes)) return [];
  return routes
    .map((r) => r?.path)
    .filter((path) => typeof path === 'string')
    .filter((path) => path !== '/*' && !path.includes(':'))
    .sort();
};

// Cache lazy — evita construir el mapa en module-load time. Necesario porque
// `liftlogic.routes.js` importa páginas que terminan consumiendo este helper
// (TenantMenuItemsPage → MenuItemsContent → MenuItemForm → aquí), formando
// un ciclo. Construirlo en la primera llamada garantiza que todos los
// módulos del ciclo estén completamente evaluados.
let cache = null;

const buildCache = () => ({
  administrador: toPaths(administradorRoutes),
  ejecutivo: toPaths(ejecutivoRoutes),
  supervisor: toPaths(supervisorRoutes),
  especialista: toPaths(especialistaRoutes),
  liftlogic: toPaths(liftlogicRoutes),
});

export function listRoutesByUserType(userType) {
  if (!userType) return [];
  if (!cache) cache = buildCache();
  return cache[userType] ?? [];
}

// Solo para tests — expone el mapa completo construido. No usar en runtime.
export function getAllRoutesByUserType() {
  if (!cache) cache = buildCache();
  return cache;
}
